module.exports = __webpack_public_path__ + "static/media/cp1.12b612c0.png";